import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Grid2,
  TextField,
  Box,
} from "@mui/material";
import { useState } from "react";

const NumericPadInput = ({ label, name, value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const [padValue, setPadValue] = useState(value || "");

  const handleButtonClick = (val) => {
    setPadValue((prev) => prev + val);
  };

  const handleClear = () => setPadValue("");
  const handleBackspace = () => setPadValue((prev) => prev.slice(0, -1));
  const handleDone = () => {
    onChange(padValue);
    setOpen(false);
  };

  const keypadButtons = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "C",
    "0",
    "←",
  ];

  const handleSpecial = (val) => {
    if (val === "C") handleClear();
    else if (val === "←") handleBackspace();
    else handleButtonClick(val);
  };

  return (
    <>
      <TextField
        fullWidth
        size="small"
        disabled={disabled}
        value={value}
        onClick={() => setOpen(true)}
        readOnly
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{label}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            size="medium"
            value={padValue}
            inputProps={{
              readOnly: true,
              style: { textAlign: "center", fontSize: "1.5rem" },
            }}
            sx={{ mb: 2 }}
          />

          <Grid2 container spacing={1}>
            {keypadButtons.map((val, idx) => (
              <Grid2 item size={{ xs: 4 }} key={idx}>
                <Button
                  fullWidth
                  onClick={() => handleSpecial(val)}
                  variant="outlined"
                  sx={{ height: 56, fontSize: "1.2rem" }}
                >
                  {val}
                </Button>
              </Grid2>
            ))}
          </Grid2>

          <Box mt={3}>
            <Button fullWidth variant="contained" onClick={handleDone}>
              Done
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default NumericPadInput;
